import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Option } from '@digilize/shared/definitions/src';
import { TranslateService } from '@ngx-translate/core';
import { Education } from '../../models/education.model';
import { EducationMockService } from '../../services/education-mock.service';

@Component({
  selector: 'bwc-education-skill',
  templateUrl: './education-skill.component.html',
  styleUrls: ['./education-skill.component.scss'],
})
export class EducationSkillComponent implements OnInit {
  educations: Education[] = [];
  visibleCount = 24;
  likedIds: number[] = [];
  skillName = '';

  selectedCategorie = '';
  selectedRegio = '';
  selectedLeervorm = '';
  selectedPrijs = '';
  selectedAanbieder = '';
  selectedSubsidie = '';
  selectedStartDatum = '';
  selectedTaal = '';

  categorieControl = new FormControl('');
  regioControl = new FormControl('');
  leervormControl = new FormControl('');
  prijsControl = new FormControl('');
  aanbiederControl = new FormControl('');
  subsidieControl = new FormControl('');
  startDatumControl = new FormControl('');
  taalControl = new FormControl('');

  categorieOptions: Option[] = [];
  regioOptions: Option[] = [];
  leervormOptions: Option[] = [];
  prijsOptions: Option[] = [];
  aanbiederOptions: Option[] = [];
  subsidieOptions: Option[] = [];
  startDatumOptions: Option[] = [];
  taalOptions: Option[] = [];

  constructor(
    private route: ActivatedRoute,
    private educationService: EducationMockService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const raw = decodeURIComponent(params['skillName'] || '');
      this.skillName = raw.charAt(0).toUpperCase() + raw.slice(1);
      this.educationService.getEducationsBySkill(this.skillName).subscribe(e => (this.educations = e));
    });
    this.likedIds = this.educationService.getSavedIds();

    this.categorieOptions = [
      { text: this.translateService.instant('educations.skill.filter_all_categories'), val: '' },
      { text: this.translateService.instant('educations.search.filter_business'), val: 'bedrijfsbeheer' },
      { text: this.translateService.instant('educations.search.filter_finance'), val: 'financien' },
      { text: this.translateService.instant('educations.search.filter_marketing_sales'), val: 'marketing' },
      { text: this.translateService.instant('educations.search.filter_it'), val: 'it' },
      { text: this.translateService.instant('educations.search.filter_languages_comm'), val: 'talen' },
      { text: this.translateService.instant('educations.search.filter_hr'), val: 'hr' },
      { text: this.translateService.instant('educations.search.filter_legal'), val: 'juridisch' },
      { text: this.translateService.instant('educations.search.filter_personal_dev'), val: 'persoonlijk' },
    ];
    this.regioOptions = [
      { text: this.translateService.instant('educations.skill.filter_all_regions'), val: '' },
      { text: 'Online', val: 'online' },
      { text: 'Antwerpen', val: 'antwerpen' },
      { text: 'Brussel', val: 'brussel' },
      { text: 'Limburg', val: 'limburg' },
      { text: 'Oost-Vlaanderen', val: 'oost-vlaanderen' },
      { text: 'Vlaams-Brabant', val: 'vlaams-brabant' },
      { text: 'West-Vlaanderen', val: 'west-vlaanderen' },
    ];
    this.leervormOptions = [
      { text: this.translateService.instant('educations.skill.filter_all_learning_forms'), val: '' },
      { text: this.translateService.instant('educations.search.filter_distance_learning'), val: 'afstandsleren' },
      { text: this.translateService.instant('educations.search.filter_classroom'), val: 'klassikaal' },
      { text: 'Online', val: 'online' },
      { text: 'Blended learning', val: 'blended' },
      { text: this.translateService.instant('educations.search.filter_evening'), val: 'avondonderwijs' },
    ];
    this.prijsOptions = [
      { text: this.translateService.instant('educations.skill.filter_all_prices'), val: '' },
      { text: this.translateService.instant('educations.search.filter_free'), val: 'gratis' },
      { text: '\u20AC0 - \u20AC500', val: '0-500' },
      { text: '\u20AC500 - \u20AC1.000', val: '500-1000' },
      { text: '\u20AC1.000 - \u20AC2.500', val: '1000-2500' },
      { text: '\u20AC2.500+', val: '2500+' },
    ];
    this.aanbiederOptions = [
      { text: this.translateService.instant('educations.skill.filter_all_providers'), val: '' },
      { text: 'LOI', val: 'loi' },
      { text: 'NHA Afstandsonderwijs', val: 'nha' },
      { text: 'NCOI', val: 'ncoi' },
      { text: 'Syntra', val: 'syntra' },
      { text: 'VDAB', val: 'vdab' },
      { text: "CVO's", val: 'cvo' },
    ];
    this.subsidieOptions = [
      { text: this.translateService.instant('educations.skill.filter_all_educations'), val: '' },
      { text: this.translateService.instant('educations.search.filter_kmo_portefeuille'), val: 'kmo-portefeuille' },
      { text: this.translateService.instant('educations.search.filter_vdab_opleiding'), val: 'vdab' },
      { text: this.translateService.instant('educations.search.filter_opleidingscheques'), val: 'opleidingscheques' },
      { text: this.translateService.instant('educations.search.filter_no_subsidy'), val: 'geen' },
    ];
    this.startDatumOptions = [
      { text: this.translateService.instant('educations.skill.filter_all_start_dates'), val: '' },
      { text: this.translateService.instant('educations.search.filter_start_now'), val: 'direct' },
      { text: this.translateService.instant('educations.search.filter_this_month'), val: 'deze-maand' },
      { text: this.translateService.instant('educations.search.filter_next_month'), val: 'volgende-maand' },
      { text: this.translateService.instant('educations.search.filter_this_quarter'), val: 'dit-kwartaal' },
      { text: this.translateService.instant('educations.search.filter_flexible'), val: 'flexibel' },
    ];
    this.taalOptions = [
      { text: this.translateService.instant('educations.skill.filter_all_languages'), val: '' },
      { text: this.translateService.instant('educations.search.filter_dutch'), val: 'nederlands' },
      { text: this.translateService.instant('educations.search.filter_english'), val: 'engels' },
      { text: this.translateService.instant('educations.search.filter_french'), val: 'frans' },
      { text: this.translateService.instant('educations.search.filter_german'), val: 'duits' },
    ];
  }

  get visibleEducations(): Education[] {
    return this.educations.slice(0, this.visibleCount);
  }

  get hasMore(): boolean {
    return this.visibleCount < this.educations.length;
  }

  loadMore(): void {
    this.visibleCount = Math.min(this.visibleCount + 24, this.educations.length);
  }

  isLiked(id: number): boolean {
    return this.likedIds.includes(id);
  }

  toggleLike(education: Education): void {
    const saved = this.educationService.toggleSaveEducation(education);
    this.likedIds = saved
      ? [...this.likedIds, education.id]
      : this.likedIds.filter(i => i !== education.id);
  }

  onCategorieSelected(option: Option): void {
    this.selectedCategorie = option?.val || '';
  }

  onRegioSelected(option: Option): void {
    this.selectedRegio = option?.val || '';
  }

  onLeervormSelected(option: Option): void {
    this.selectedLeervorm = option?.val || '';
  }

  onPrijsSelected(option: Option): void {
    this.selectedPrijs = option?.val || '';
  }

  onAanbiederSelected(option: Option): void {
    this.selectedAanbieder = option?.val || '';
  }

  onSubsidieSelected(option: Option): void {
    this.selectedSubsidie = option?.val || '';
  }

  onStartDatumSelected(option: Option): void {
    this.selectedStartDatum = option?.val || '';
  }

  onTaalSelected(option: Option): void {
    this.selectedTaal = option?.val || '';
  }
}
